import * as NavigationConstants from "../constants/navigation";

export const NavigateAction = (route) => {
	return {
		type: NavigationConstants.NAVIGATE_TO,
		destination: route,
	};
};
